
import { defineComponent, ref, reactive, toRefs, onMounted, computed, watch, watchEffect, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import Collapse from '@/components/paragraphColl.vue'
import Nodata from '@/components/page/nodata.vue'
import api from '@/api/allApi'
import globalsets from '@/utils/globalsets'
export default defineComponent({
  props: {
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { Collapse, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      btnShow: false,
      rows: 2,
      data: [],
      spinning: true
    })
    watchEffect(() => {
      const data = (props.pageSourceData || {}).InvestorInteraction
      pageData.data = handlerData(data)
    })
    function handlerData(arr: any) {
      nextTick(() => {
        pageData.spinning = false
      })
      if ((arr || []).length < 1) return []
      arr.forEach((element: any) => {
        element.CreateT = globalsets.formatTime(element.CreateTime)
        element.ReplyT = globalsets.formatTime(element.ReplyTime)
      })
      return arr
    }
    return {
      ...toRefs(pageData)
    }
  }
})
